export const comments_5053768 = {"data":{"data":[],"links":{}}}